import { render } from "./AwaitLogout.vue?vue&type=template&id=f4c7dc72"
import script from "./AwaitLogout.vue?vue&type=script&lang=js"
export * from "./AwaitLogout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__